/** Determina si el parametro es null */
export function isNull(value) {
    return value === null;
}
/** Determina si el parametro es undefined */
export function isUndefined(value) {
    return value === undefined;
}
/** Determina si el parametro es null o undefined */
export function isNullOrUndefined(value) {
    return isNull(value) || isUndefined(value);
}
/** Determina si el parametro NO es null */
export function isNotNull(value) {
    return value !== null;
}
/** Determina si el parametro NO es undefined */
export function isNotUndefined(value) {
    return value !== undefined;
}
/** Determina si el parametro NO es null NI undefined */
export function isNotNullOrUndefined(value) {
    return isNotNull(value) && isNotUndefined(value);
}
/** Alias para `isNotNullOrUndefined()` */
export const isDefined = isNotNullOrUndefined;
//# sourceMappingURL=general.js.map